import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

class HiddenInput extends Component {
    static propTypes = {
        input: PropTypes.object
    };

    render() {
        const { input } = this.props;

        return (
            <div>
                <Form.Control type={'hidden'} {...input} />
            </div>
        );
    }
}

export default HiddenInput;
